import React from 'react';

import { isNotNil } from 'es-toolkit';
import { isEmpty } from 'es-toolkit/compat';

import { EmployerWhere, useEmployersTableListQuery } from 'src/api';
import { ModalId } from 'src/constants/modals';
import { useFilterStorage, useSearchQueryVariables } from 'src/hooks/common';
import { useCurrentPeoStaff } from 'src/hooks/peoStaff';
import {
  prepareEmployerSearchFilterByCategories,
  prepareEmployersFilterByStatus,
} from 'src/utils/employer';
import { gql } from 'src/utils/gql';

import { EmployersInnerTablePEOStaff } from './EmployersInnerTablePEOStaff';

export const EmployersTablePEOStaff: React.FC = () => {
  const searchQueryVariables = useSearchQueryVariables(prepareEmployerSearchFilterByCategories);
  const { filter, sortQueryVariable, paginationQueryVariables, pagination } = useFilterStorage();
  const { peoId } = useCurrentPeoStaff();

  const peoFilter: EmployerWhere = React.useMemo(() => {
    return {
      peoId: { equals: peoId },
    };
  }, [peoId]);

  const {
    data: employers,
    loading,
    refetch,
  } = useEmployersTableListQuery({
    variables: {
      filter: gql.wrapToAND<EmployerWhere[]>(
        [searchQueryVariables, peoFilter, prepareEmployersFilterByStatus(filter)]
          .filter(isNotNil)
          .filter(item => !isEmpty(item)),
      ),
      ...paginationQueryVariables,
      orderBy: sortQueryVariable,
    },
    notifyOnNetworkStatusChange: true,
  });

  const refetchData = React.useCallback(async () => {
    await refetch();
    pagination.resetPage();
  }, [pagination, refetch]);

  const employersList = React.useMemo(() => {
    return employers?.employerList ?? [];
  }, [employers?.employerList]);

  const employersCount = React.useMemo(() => {
    return employers?.employerCount || 0;
  }, [employers?.employerCount]);

  return (
    <EmployersInnerTablePEOStaff
      employersList={employersList}
      employersCount={employersCount}
      loading={loading}
      inviteModalId={ModalId.InviteEmployersAdminsByPeoStaff}
      pagination={pagination}
      onRefresh={refetchData}
    />
  );
};
